import instance from "./base";

const get = async (route) => {
  try {
    const response = await instance.get(route);
    return response.data;
  } catch (e) {
    throw e;
  }
};

const post = async (route, data) => {
  try {
    const response = await instance.post(route, {
      headers: {
        "Content-Type": "application/json",
      },
      ...data,
    });

    return response.data;
  } catch (e) {
    throw e;
  }
};

export { get, post };
